import { IState } from '../../store';

export const selectCallbackWidgetOpened = (state: IState): boolean =>
  state.newbuildingBrokerOfferBooking.callbackWidgetOpened;
